import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const AuctionModuleCard = ({ badge, badgeText = 'Planned', eyebrow = 'Auction module', module }) => (
  <div className="card shadow-sm h-100 border-0 auction-management-card">
    <div className="card-body d-flex flex-column gap-3">
      <div className="d-flex justify-content-between align-items-start gap-2">
        <div>
          <p className="eyebrow text-uppercase text-primary fw-semibold mb-1">{eyebrow}</p>
          <h2 className="h5 mb-2">{module.title}</h2>
          <p className="text-muted mb-0">{module.description}</p>
        </div>
        {badge || (badgeText ? <span className="badge bg-primary-subtle text-primary-emphasis">{badgeText}</span> : null)}
      </div>
      <ul className="list-unstyled mb-0 d-flex flex-column gap-2">
        {module.bullets.map((bullet) => (
          <li key={`${module.id || module.title}-${bullet}`} className="d-flex align-items-start gap-2">
            <span className="auction-management-check">✓</span>
            <span className="text-muted">{bullet}</span>
          </li>
        ))}
      </ul>
      {module.actions && (
        <div className="d-flex flex-wrap gap-2">
          {module.actions.map((action) => (
            <Link key={`${module.id || module.title}-${action.to}-${action.label}`} to={action.to} className={`btn btn-${action.variant}`}>
              {action.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  </div>
);

AuctionModuleCard.propTypes = {
  badgeText: PropTypes.string,
  badge: PropTypes.node,
  eyebrow: PropTypes.string,
  module: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    bullets: PropTypes.arrayOf(PropTypes.string).isRequired,
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        to: PropTypes.string.isRequired,
        variant: PropTypes.string.isRequired,
      })
    ),
  }).isRequired,
};

AuctionModuleCard.defaultProps = {
  badgeText: 'Planned',
  eyebrow: 'Auction module',
};

export default AuctionModuleCard;
